<template>
    <div>
        <div class="vod-summary-title">
            {{ conference.title }}
        </div>
        <div
            class="single-webinar"
            style="margin-top: 1.5rem;"
            v-for="webinar in conferenceWebinars"
            :key="webinar.uuid"
        >
            <div class="summary-image">
                <img :src="webinar.thumbnail" />
            </div>
            <div class="summary-list">
                <h3>{{ webinar.title }}</h3>
                <ul v-if="!$Utils.isWinterInspiration(conference.uuid)">
                    <li>Materiały dodatkowe do pobrania</li>
                    <li>Zaświadczenie o ukończeniu E-szkolenia</li>
                </ul>
                <ul v-else>
                    <p v-text="webinarRows(webinar)" />
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import winterInspiration from '@/views/VOD/winterInspiration.json'
export default {
    props: {
        conference: Object
    },
    computed: {
        conferenceWebinars() {
            return this.$store.getters['content/webinarsByConference'](
                this.conference.uuid
            )
        }
    },
    methods: {
        webinarRows({ uuid }) {
            return winterInspiration[uuid] ? winterInspiration[uuid] : ''
        }
    }
}
</script>
<style lang="scss" scoped>
ul {
    padding: 0 1rem;
}
li {
    margin-bottom: 0.5rem;
}
.vod-summary-title {
    font-size: 2.5rem;
    font-family: $input-family;
}
.summary-image {
    flex: 2;

    img {
        width: 100%;
    }
}
.single-webinar {
    display: flex;
}
.summary-list {
    font-size: 1.2rem;
    margin-left: 2rem;
    flex: 4;
    line-height: 1.4rem;

    div {
        margin-bottom: 0.2rem;
    }

    h3 {
        margin: 0;
        margin-bottom: 0.5rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        text-transform: uppercase;
    }
}

@media (max-width: 1000px) {
    .vod-summary-title {
        font-size: 1.5rem;
        font-family: $header-family;
        max-width: 85%;
    }

    .single-webinar {
        flex-direction: column;
    }
    .summary-list {
        h3 {
            font-size: 1.1rem;
            font-family: $input-family;
            text-transform: none;
            margin-left: -2rem;
            margin-bottom: -0.2rem;
            margin-top: 1rem;
        }
        ul {
            padding: 0;
            list-style-type: none;
            margin: 0;
            margin-top: 1rem;
            margin-left: -2rem;

            li {
                margin-top: 0.2rem;
                font-family: $input-family;
                &::before {
                    content: '\2022';
                    color: $accent-apple;
                    font-size: 40px;
                    margin-right: 0.3rem;
                    position: relative;
                    top: 0.375rem;
                }
            }
        }
    }
}
</style>
